import React, { useState, useCallback, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { Typography, CircularProgress, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DriverSpecificMap from "./DriverSpecificMap";
// import routeeyeIcon from "../../images/organization/routeeyeIcon.svg";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import Busstop from "../../images/driverConsole/Busstop.svg";
import behindBus from "../../images/driverConsole/behindBus.svg";
import busAhead from "../../images/driverConsole/busAhead.svg";
import busFlag from "../../images/driverConsole/bxs-flag.svg.svg";
import busLocation from "../../images/driverConsole/bxs-map.svg.png";
import distnaceIcon from "../../images/driverConsole/bxs-ruler.svg.svg";
import speedIcon from "../../images/driverConsole/bxs-tachometer.svg.svg";
import etaIcon from "../../images/driverConsole/bxs-time.svg.svg";
import axios from "axios";
import config from "../../config.js";
import { getVehicleAndRouteDetails } from "./DriverConsoleAPI.js";
import { useSettings } from "../../context/SettingsContext";
import { getIsDemo } from "../../utils/helperFunction.js";
import DriverDemoSpecificMap from "./DriverDemoSpecificMap.jsx";
import RouteEyeIcon from "../../images/image.png";

const Container = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "98vh",
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  fontFamily: "Roboto, -apple-system, BlinkMacSystemFont, sans-serif",
  backgroundColor: "#f5f5f5",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    height: "auto",
    minHeight: "100vh",
  },
}));

const MapContainer = styled(Box)(({ theme }) => ({
  padding: "20px",
  width: "40%",
  position: "relative",
  overflow: "hidden",
  height: "100vh",

  [theme.breakpoints.down("md")]: {
    width: "100%",
    height: "90vh",
  },
  [theme.breakpoints.down("sm")]: {
    height: "80vh",
    padding: "10px",
  },
}));

const MapBackground = styled(Box)({
  width: "100%",
  height: "100%",
  border: "1px solid #183059",
  borderRadius: "16px",
  backgroundImage: `
    repeating-linear-gradient(
      45deg,
      #f0f0f0 0px,
      #f0f0f0 1px,
      transparent 1px,
      transparent 15px
    ),
    repeating-linear-gradient(
      -45deg,
      #f0f0f0 0px,
      #f0f0f0 1px,
      transparent 1px,
      transparent 15px
    )`,
  position: "relative",
});

const RightPanel = styled(Box)(({ theme }) => ({
  width: "58%",
  display: "flex",
  flexDirection: "column",
  margin: "30px 10px",
  padding: "20px 20px 20px 0px",
  height: "100vh",
  marginTop: "30px",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    margin: "10px 0",
    height: "auto",
    padding: "10px",
  },
}));

const RouteHeader = styled(Box)(({ theme }) => ({
  padding: "10px 10px",
  borderBottom: "2px solid #2196f3",
  backgroundColor: " #ffffff",
  boxShadow: "-2px 4px 4px 0px #00000040",
  border: "1px solid #a5dcf3",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));
const RouteRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  // marginBottom: "16px",
});

const TimeRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-evenly",
  color: "#46597a",
  fontSize: "32px",
  fontWeight: 500,
  [theme.breakpoints.down("sm")]: {
    fontSize: "36px",
  },
}));

const NextStopSection = styled(Box)(({ theme }) => ({
  borderBottom: "1px solid #e0e0e0",
  margin: "20px 0",
  // backgroundColor:" #ffffff",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const MobileRowContainer = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "16px",
  },
}));
const MobileStatsRow = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    gap: "8px",
    marginBottom: "12px",
  },
}));

const MobileStatCard = styled(Box)({
  flex: 1,
  background: "linear-gradient(254.22deg, #a5dcf3 -26.56%, #ffffff 50.1%)",
  padding: "8px",
  borderRadius: "8px",
  textAlign: "center",
  boxShadow: "-2px 4px 4px 0px #00000040",
  border: "1px solid #a5dcf3",
});

const MobileVehicleRow = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    gap: "8px",
    marginBottom: "12px",
  },
}));

const NextStopHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  marginBottom: "16px",
  gap: "6px",
  backgroundColor: " #ffffff",
  flexDirection: "column",
  border: "3px solid white",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
  borderRadius: "8px",
  padding: "8px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const NextStopIcon = styled(Box)({
  display: "flex",
  alignItems: "center",
});

const NextStopTitle = styled(Typography)({
  fontSize: "40px",
  fontWeight: "bold",
  color: "#111214",
});

const StatsRow = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "16px",
  marginBottom: "16px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: "8px",
  },
}));

const StatCard = styled(Box)({
  flex: 1,
  background: "linear-gradient(254.22deg, #a5dcf3 -26.56%, #ffffff 50.1%)",
  padding: "12px",
  borderRadius: "8px",
  textAlign: "left",
  boxShadow: "-2px 4px 4px 0px #00000040",
  border: "1px solid #a5dcf3",
});

const StatHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "8px",

  gap: "10px",
});

const StatValue = styled(Box)(({ theme }) => ({
  fontSize: "28px",
  fontWeight: "bold",
  lineHeight: 1,
  display: "flex",
  alignItems: "center",
  gap: "6px",
  paddingTop: "10px",
  "& span": {
    fontWeight: 800,
    fontSize: "28px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "24px",
    "& span": {
      fontSize: "24px",
    },
  },
}));

const StatUnit = styled(Box)(({ theme }) => ({
  color: "black",
  fontSize: "22px",
  marginTop: "2px",
  fontWeight: "900",
  [theme.breakpoints.down("sm")]: {
    fontSize: "10px",
  },
}));

const VehicleRow = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "16px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: "8px",
  },
}));

const VehicleCard = styled(Box)({
  flex: 1,
  display: "flex",
  minHeight: "80px",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "10px",
  padding: "12px",
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  border: "1px solid #a5dcf3",
  boxShadow: "-2px 4px 4px 0px #00000040",
});

const VehicleText = styled(Box)({
  marginLeft: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "20px",
});

const SOSButton = styled(Box)(({ theme }) => ({
  color: "white",
  background: "linear-gradient(180deg, #f0483e 0%, #d72020 100%)",
  fontSize: "24px",
  height: "60px",
  borderRadius: "40px",
  padding: "15px 30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  border: "none",
  cursor: "pointer",
  "&:hover": {
    background: "linear-gradient(180deg, #d72020 0%, #f0483e 100%)",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
    height: "48px",
    padding: "10px 20px",
  },
}));

const PoweredBy = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  "& span": {
    fontSize: "16px",
  },
  [theme.breakpoints.down("sm")]: {
    "& span": {
      fontSize: "14px",
    },
  },
}));

const RouteEyeBadge = styled(Box)(({ theme }) => ({
  color: "#111214",
  fontSize: "16px",
  fontWeight: 700,
  background: "none",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

const RouteyeLogo = styled("img")({
  width: "22px",
  height: "22px",
});

const resolveSpeedLimit = (maxSpeed) => {
  const limit = Number(maxSpeed);
  return Number.isFinite(limit) && limit > 0 ? limit : null;
};

const WarningIcon = ({ color = "white", size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
  </svg>
);

const DriverConsoleCont = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const settingsState = useSettings();
  const speedLimit = resolveSpeedLimit(settingsState?.settings?.maxSpeed);

  // Add helper function to format time
  const formatTime = (isoString) => {
    if (!isoString) return "--:--";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return "--:--";

    // Check if date is expired
    if (date < new Date()) return "--:--";

    return date
      .toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .toLowerCase();
  };

  // Add function to get schedule times
  const getScheduleTimes = (schedules) => {
    if (!schedules || schedules.length === 0) {
      return {
        startTime: "Not scheduled",
        endTime: "Not scheduled",
      };
    }

    const now = new Date();

    // Sort schedules by start time to get the most recent one
    const sortedSchedules = [...schedules].sort(
      (a, b) => new Date(a.startTime) - new Date(b.startTime)
    );

    // Get the active schedule (first non-expired one)
    const activeSchedule = sortedSchedules.find(
      (schedule) => new Date(schedule.endTime) > now
    );

    if (!activeSchedule) {
      return {
        startTime: "Expired",
        endTime: "Expired",
      };
    }

    const startDate = new Date(activeSchedule.startTime);
    const endDate = new Date(activeSchedule.endTime);

    // If start time is in the future
    if (startDate > now) {
      return {
        startTime: startDate
          .toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          .toLowerCase(),
        endTime: endDate
          .toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          .toLowerCase(),
      };
    }

    // If currently active
    if (startDate <= now && endDate > now) {
      return {
        startTime: startDate
          .toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          .toLowerCase(),
        endTime: endDate
          .toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          .toLowerCase(),
      };
    }

    return {
      startTime: "--:--",
      endTime: "--:--",
    };
  };

  const [mapConfig, setMapConfig] = useState({
    center: { lat: 28.6139, lng: 77.209 },
    zoom: 14,
  });
  const [nextStopData, setNextStopData] = useState({
    nextStopName: null,
    distance: null,
    eta: null,
    sourceStop: null,
    destinationStop: null,
    speed: null,
    behindVehicle: null,
    aheadVehicle: null,
    schedules: [], // Add this line
  });

  const [isSendingSOS, setIsSendingSOS] = useState(false);
  const [routeDetails, setRouteDetails] = useState({
    routeName: "",
    vehicleName: "",
  });
  // Add new state for vehicle position
  const [vehiclePosition, setVehiclePosition] = useState(null);

  const wasOverSpeedingRef = useRef(false);

  const isOverSpeeding =
    speedLimit != null &&
    nextStopData.speed !== null &&
    Number.isFinite(Number(nextStopData.speed)) &&
    Number(nextStopData.speed) > speedLimit;

  // Web Speech API Over-Speed Voice Alerts (Announces ONCE when vehicle over-speeds using locale translation files)
  useEffect(() => {
    if (isOverSpeeding && typeof window !== "undefined" && "speechSynthesis" in window) {
      if (!wasOverSpeedingRef.current) {
        wasOverSpeedingRef.current = true;
        window.speechSynthesis.cancel();

        const activeLang = (i18n?.language || localStorage.getItem("i18nextLng") || "en").toLowerCase();

        // Get translated voice alert text directly from i18n translation files (src/locales)
        const text = t("overspeedVoiceAlert", {
          speed: nextStopData.speed,
          defaultValue: `Warning! Speed limit exceeded. Your current speed is ${nextStopData.speed} kilometers per hour. Please slow down.`,
        });

        // Determine matching Web Speech API locale tag
        let localeTag = "en-US";
        if (activeLang.startsWith("kn") || activeLang === "ka") localeTag = "kn-IN";
        else if (activeLang.startsWith("hi")) localeTag = "hi-IN";
        else if (activeLang.startsWith("fr")) localeTag = "fr-FR";
        else if (activeLang.startsWith("es")) localeTag = "es-ES";
        else if (activeLang.startsWith("de")) localeTag = "de-DE";
        else if (activeLang.startsWith("zh") || activeLang.startsWith("cn")) localeTag = "zh-CN";
        else if (activeLang.startsWith("ar") || activeLang.startsWith("sa")) localeTag = "ar-SA";

        const alertMsg = new SpeechSynthesisUtterance(text);
        alertMsg.lang = localeTag;
        alertMsg.rate = 1.0;
        alertMsg.pitch = 1.0;

        // Find best matching system voice for the target language (e.g., Kannada, Hindi, etc.)
        const voices = window.speechSynthesis.getVoices();
        const langPrefix = localeTag.split("-")[0];
        const matchingVoice = voices.find(
          (v) => v.lang === localeTag || v.lang.startsWith(langPrefix)
        );
        if (matchingVoice) {
          alertMsg.voice = matchingVoice;
        }

        window.speechSynthesis.speak(alertMsg);
      }
    } else if (!isOverSpeeding) {
      wasOverSpeedingRef.current = false;
      if (typeof window !== "undefined" && "speechSynthesis" in window) {
        window.speechSynthesis.cancel();
      }
    }
  }, [isOverSpeeding, nextStopData.speed, speedLimit, i18n?.language, t]);

  // Clean up speech on component unmount
  useEffect(() => {
    return () => {
      if (typeof window !== "undefined" && "speechSynthesis" in window) {
        window.speechSynthesis.cancel();
      }
    };
  }, []);

  const queryParams = new URLSearchParams(location.search);
  const routeId = queryParams.get("routeId");
  const orgId = queryParams.get("organizationId");
  const vehicleId = queryParams.get("vehicleId");

  const userState = JSON.parse(localStorage.getItem("userState") || "{}");
  const userObj = JSON.parse(localStorage.getItem("user") || "{}");
  const effectiveOrgId =
    orgId ||
    queryParams.get("orgId") ||
    userState?.user?.organizationId ||
    userObj?.organizationId;

  // Replace hardcoded times with dynamic ones
  const { startTime, endTime } = getScheduleTimes(nextStopData.schedules);

  const handleNextStopUpdate = useCallback((data) => {
    setNextStopData({
      nextStopName: data.nextStopName || "Loading...",
      distance:
        data.distance !== null && isFinite(data.distance)
          ? data.distance.toFixed(1)
          : "0.0",
      eta: data.eta || "N/A",
      sourceStop: data.sourceStop || "Loading...",
      destinationStop: data.destinationStop || "Loading...",
      speed:
        data.speed !== null && isFinite(data.speed)
          ? Math.round(data.speed)
          : 0,
      behindVehicle: data.behindVehicle || "N/A",
      aheadVehicle: data.aheadVehicle || "N/A",
      schedules: data.schedules || [],
    });
  }, []);

  const fetchRouteAndVehicleDetails = async () => {
    try {
      const details = await getVehicleAndRouteDetails(
        vehicleId,
        routeId,
        effectiveOrgId
      );
      setRouteDetails({
        routeName: details.routeName || "Unknown Route",
        vehicleName: details.vehicleName || "Unknown Vehicle",
        transportInchargePhone: details.transportInchargePhone || null,
        driverName: details.driverName || userObj?.name || userObj?.fullName || "Driver",
        driverPhone: details.driverPhone || userObj?.phone || userObj?.phoneNumber || userObj?.mobile || null,
      });
      console.log("[SOS Container] Updated routeDetails:", {
        routeName: details.routeName,
        vehicleName: details.vehicleName,
        driverName: details.driverName,
        driverPhone: details.driverPhone || userObj?.phone,
        transportInchargePhone: details.transportInchargePhone,
      });
    } catch (error) {
      console.error("Failed to fetch route/vehicle details:", error);
      setRouteDetails({
        routeName: "Unknown Route",
        vehicleName: "Unknown Vehicle",
        transportInchargePhone: null,
        driverName: "Driver",
        driverPhone: null,
      });
    }
  };

  const syncPendingSOSAlerts = async () => {
    if (!navigator.onLine) return;
    const pendingAlerts = JSON.parse(
      localStorage.getItem("pending_sos_alerts") || "[]"
    );
    if (pendingAlerts.length === 0) return;

    console.log(`[SOS] Back online! Retrying ${pendingAlerts.length} queued alert(s)...`);
    const remainingAlerts = [];
    for (const alertItem of pendingAlerts) {
      try {
        await axios.post(`${config.baseURL}/alert`, alertItem);
        console.log("[SOS] Queued alert sent successfully!");
      } catch (err) {
        console.error("[SOS] Failed to send queued alert, keeping in queue:", err);
        remainingAlerts.push(alertItem);
      }
    }
    localStorage.setItem("pending_sos_alerts", JSON.stringify(remainingAlerts));
  };

  useEffect(() => {
    fetchRouteAndVehicleDetails();

    const handleOnline = () => {
      syncPendingSOSAlerts();
    };

    window.addEventListener("online", handleOnline);
    syncPendingSOSAlerts();

    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, [routeId, vehicleId, effectiveOrgId]);

  // Add position update handler near other handlers
  const handlePositionUpdate = useCallback((position) => {
    if (position && position.lat && position.lng) {
      setVehiclePosition(position);
    }
  }, []);

  const handleSOSClick = async () => {
    if (isSendingSOS) return;

    try {
      setIsSendingSOS(true);

      // Extract Logged-in User Email & Driver / Vehicle / GPS Details
      const userObj = JSON.parse(localStorage.getItem("user") || "{}");

      // Dynamic Transport In-Charge Phone (with local dev fallback if local DB record has null)
      const transportInchargePhone =
        routeDetails.transportInchargePhone ||
        userObj?.transportInchargePhone ||
        "7845635255";

      const callingNumber = transportInchargePhone;
      const driverPhone = transportInchargePhone;

      const userEmail =
        localStorage.getItem("userEmail") ||
        localStorage.getItem("email") ||
        userObj.email ||
        userObj.userEmail ||
        "admin@routeeye.com";

      const driverName =
        routeDetails.driverName ||
        userObj.name ||
        userObj.fullName ||
        userObj.userName ||
        "Driver";

      const baseUrl =
        process.env.REACT_APP_FRONTEND_URL || window.location.origin;
      const appLocationUrl = `${baseUrl}/vehicle/track?vehicleId=${vehicleId || ""
        }&organizationId=${orgId || ""}&routeId=${routeId || ""}`;

      // Determine Latitude and Longitude with Fallbacks
      let currentLat = vehiclePosition?.lat || mapConfig?.center?.lat;
      let currentLng = vehiclePosition?.lng || mapConfig?.center?.lng;

      if (!currentLat || !currentLng) {
        if (nextStopData?.sourceStopCoordinates?.lat) {
          currentLat = nextStopData.sourceStopCoordinates.lat;
          currentLng = nextStopData.sourceStopCoordinates.lng;
        } else if (nextStopData?.destinationStopCoordinates?.lat) {
          currentLat = nextStopData.destinationStopCoordinates.lat;
          currentLng = nextStopData.destinationStopCoordinates.lng;
        }
      }

      const googleMapsUrl =
        currentLat && currentLng
          ? `https://www.google.com/maps?q=${currentLat},${currentLng}`
          : null;

      // Detailed Email Body containing Driver, Vehicle, Coordinates & Dual Location Links (No Screenshot)
      const emailBody =
        `EMERGENCY SOS ALERT!\n\n` +
        `DRIVER DETAILS:\n` +
        `• Name: ${driverName}\n` +
        `• Contact Phone: ${driverPhone}\n` +
        `• Triggered By: ${userEmail}\n\n` +
        `VEHICLE & ROUTE DETAILS:\n` +
        `• Vehicle Name: ${routeDetails.vehicleName || "Vehicle"}\n` +
        `• Route Name: ${routeDetails.routeName || "Route"}\n` +
        `• Next Stop: ${nextStopData.nextStopName || "Unknown"}\n` +
        `• Distance to Next Stop: ${nextStopData.distance || 0} km\n` +
        `• ETA: ${nextStopData.eta || "N/A"}\n` +
        `• Current Speed: ${nextStopData.speed || 0} km/h\n\n` +
        `LOCATION COORDINATES:\n` +
        `• Latitude: ${currentLat || "N/A"}\n` +
        `• Longitude: ${currentLng || "N/A"}\n\n` +
        `OPEN DIRECTLY IN ROUTEEYE APP:\n` +
        `${appLocationUrl}\n\n` +
        `OPEN EXTERNAL GOOGLE MAPS NAVIGATION:\n` +
        `${googleMapsUrl || "Location Unavailable"}`;

      const alertData = {
        subject: `EMERGENCY SOS ALERT - ${routeDetails.vehicleName || "Vehicle"
          } (Driver: ${driverName})`,
        body: emailBody,
        alertType: "EMERGENCY",
        medium: "EMAIL_AND_APP",
        sendEmail: true,
        sendToOrgUsers: true,
        targetAudience: "ORGANIZATION_USERS",
        organizationId: orgId,
        routeId: routeId,
        vehicleId: vehicleId,
        latitude: currentLat || null,
        longitude: currentLng || null,
        appLocationUrl: appLocationUrl,
        googleMapsUrl: googleMapsUrl,
        driverName: driverName,
        driverPhone: driverPhone,
        vehicleName: routeDetails.vehicleName,
        routeName: routeDetails.routeName,
        alertStatus: "ACTIVE",
        statusFlag: "UNREAD",
        userName: driverName,
        timestamp: new Date().toISOString(),
      };

      console.log(
        "[SOS] Alert Payload (Sent via API without storing links in DB):",
        alertData
      );

      // STEP 1: Dispatch location payload alert asynchronously in background (non-blocking)
      (async () => {
        try {
          if (navigator.onLine) {
            const response = await axios.post(`${config.baseURL}/alert`, alertData);
            console.log("SOS alert sent successfully via API", response.data);
          } else {
            throw new Error("Device is offline");
          }
        } catch (apiErr) {
          console.warn(
            "[SOS] Network error or device offline during API call. Saving alert to offline queue:",
            apiErr
          );
          const pendingAlerts = JSON.parse(
            localStorage.getItem("pending_sos_alerts") || "[]"
          );
          pendingAlerts.push(alertData);
          localStorage.setItem("pending_sos_alerts", JSON.stringify(pendingAlerts));
        }
      })();

      // STEP 2: IMMEDIATELY trigger phone call without waiting for network API response
      if (callingNumber) {
        console.log(
          `[SOS] Initiating call to Transport In-Charge (${callingNumber})...`
        );
        window.location.href = `tel:${callingNumber}`;
      } else {
        console.warn(
          "[SOS] No Transport In-Charge phone number found in DB for this organization."
        );
      }
    } catch (error) {
      console.error("Failed to process SOS alert:", error);
    } finally {
      setIsSendingSOS(false);
    }
  };

  return (
    <Container>
      <MapContainer>
        <MapBackground>
          {getIsDemo() ? (
            <DriverDemoSpecificMap
              routeId={routeId}
              orgId={orgId}
              vehicleId={vehicleId}
              onNextStopUpdate={handleNextStopUpdate}
              onPositionUpdate={handlePositionUpdate}
              isOverSpeeding={isOverSpeeding}
            />
          ) : (
            <DriverSpecificMap
              routeId={routeId}
              orgId={orgId}
              vehicleId={vehicleId}
              onNextStopUpdate={handleNextStopUpdate}
              onPositionUpdate={handlePositionUpdate}
              isOverSpeeding={isOverSpeeding}
            />
          )}

          {/* Overspeed Badge Card positioned on bottom-left inside MapBackground above timer box */}
          {isOverSpeeding && (
            <Box
              sx={{
                position: "absolute",
                bottom: "85px",
                left: "15px",
                zIndex: 1004,
                backgroundColor: "#FFFFFF",
                borderRadius: "10px",
                px: 1.5,
                py: 0.75,
                display: "flex",
                alignItems: "center",
                gap: 1,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                border: "1px solid rgba(0,0,0,0.08)",
              }}
            >
              <Box
                sx={{
                  width: "22px",
                  height: "22px",
                  backgroundColor: "#D32F2F",
                  borderRadius: "50%",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#FFFFFF",
                  fontSize: "13px",
                  fontWeight: 700,
                  lineHeight: 1,
                }}
              >
                ⚠
              </Box>
              <Typography sx={{ color: "#333333", fontSize: "13px", fontWeight: 600 }}>
                Overspeed
              </Typography>
            </Box>
          )}
        </MapBackground>
      </MapContainer>
      <RightPanel>
        <RouteHeader>
          <RouteRow>
            <Box display="flex" alignItems="center" gap={2}>
              <img src={busLocation} alt="" />
              <Box
                sx={{
                  padding: "8px",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontSize: "32px", fontWeight: 500 }}>
                  {nextStopData.sourceStop}
                </Typography>
                <Typography
                  sx={{
                    color:
                      startTime === "Not scheduled" || startTime === "Expired"
                        ? "#ff0000"
                        : "#000000",
                    fontSize: "22px",
                    fontWeight: "500",
                  }}
                >
                  {startTime}
                </Typography>
              </Box>
            </Box>
            <Box>
              <EastOutlinedIcon size={36} />
            </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <img src={busFlag} alt="" />
              <Box
                sx={{
                  padding: "8px",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontSize: "32px", fontWeight: 500, ml: 1 }}>
                  {nextStopData.destinationStop}
                </Typography>
                <Typography
                  sx={{
                    color:
                      endTime === "Not scheduled" || endTime === "Expired"
                        ? "#ff0000"
                        : "#000000",
                    fontSize: "22px",
                    fontWeight: "500",
                  }}
                >
                  {endTime}
                </Typography>
              </Box>
            </Box>
          </RouteRow>
        </RouteHeader>
        <NextStopSection>
          <NextStopHeader>
            <NextStopIcon>
              <img src={Busstop} alt="" />
              <Typography sx={{ color: "#008C23", fontSize: "20px", ml: 1 }}>
                Next Stop
              </Typography>
            </NextStopIcon>
            <NextStopTitle>{nextStopData.nextStopName}</NextStopTitle>
          </NextStopHeader>
          <StatsRow>
            <StatCard>
              <StatHeader>
                <img src={distnaceIcon} alt="" />
                <Typography
                  sx={{
                    color: "#20A8E0",
                    fontSize: "20px",
                    fontWeight: 500,
                    ml: 0.5,
                  }}
                >
                  Distance
                </Typography>
              </StatHeader>
              <StatValue>
                <Typography component="span">
                  {nextStopData.distance}
                </Typography>
                <StatUnit>km</StatUnit>
              </StatValue>
            </StatCard>
            <StatCard
              sx={
                isOverSpeeding
                  ? {
                      backgroundColor: "#ffebee",
                      border: "2px solid #d32f2f",
                      boxShadow: "0 0 10px rgba(211, 47, 47, 0.5)",
                    }
                  : {}
              }
            >
              <StatHeader>
                <img src={speedIcon} alt="" />
                <Typography
                  sx={{
                    color: isOverSpeeding ? "#d32f2f" : "#20A8E0",
                    fontSize: "20px",
                    fontWeight: isOverSpeeding ? 700 : 500,
                    ml: 0.5,
                  }}
                >
                  Speed
                </Typography>
              </StatHeader>
              <StatValue sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.75 }}>
                {isOverSpeeding && (
                  <Box
                    sx={{
                      width: "20px",
                      height: "20px",
                      backgroundColor: "#FF0000",
                      borderRadius: "50%",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#FFFFFF",
                      fontSize: "12px",
                      fontWeight: 700,
                      lineHeight: 1,
                      boxShadow: "0 2px 4px rgba(211, 47, 47, 0.4)",
                    }}
                  >
                    ⚠
                  </Box>
                )}
                <Typography component="span" sx={{ color: isOverSpeeding ? "#d32f2f" : "inherit" }}>
                  {nextStopData.speed}
                </Typography>
                <StatUnit sx={{ color: isOverSpeeding ? "#d32f2f" : "inherit" }}>km/h</StatUnit>
              </StatValue>
              {speedLimit != null && (
                <Typography
                  sx={{
                    fontSize: "11px",
                    color: isOverSpeeding ? "#d32f2f" : "#757575",
                    fontWeight: isOverSpeeding ? 600 : 400,
                    mt: 0.5,
                  }}
                >
                  Speed limit: {speedLimit} km/h
                </Typography>
              )}
            </StatCard>
            <StatCard>
              <StatHeader>
                <img src={etaIcon} alt="" />
                <Typography
                  sx={{
                    color: "#20A8E0",
                    fontSize: "20px",
                    fontWeight: 500,
                    ml: 0.5,
                  }}
                >
                  ETA
                </Typography>
              </StatHeader>
              <StatValue>
                <Typography component="span">{nextStopData.eta}</Typography>
              </StatValue>
            </StatCard>
          </StatsRow>

          <VehicleRow>
            <VehicleCard>
              <VehicleText>
                <img src={behindBus} alt="" />
                <Box>
                  <Typography
                    sx={{ fontSize: "20px", color: "#414958", fontWeight: 500 }}
                  >
                    Behind
                  </Typography>
                </Box>
              </VehicleText>
              <Typography sx={{ fontSize: "24px", fontWeight: 600 }}>
                {nextStopData.behindVehicle}
              </Typography>
            </VehicleCard>
            <VehicleCard>
              <VehicleText>
                <img src={busAhead} alt="" />
                <Box>
                  <Typography
                    sx={{ fontSize: "20px", color: "#414958", fontWeight: 500 }}
                  >
                    Ahead
                  </Typography>
                </Box>
              </VehicleText>
              <Typography sx={{ fontSize: "24px", fontWeight: 600 }}>
                {nextStopData.aheadVehicle}
              </Typography>
            </VehicleCard>
          </VehicleRow>
        </NextStopSection>
        <MobileRowContainer>
          {/* Source to Destination Row */}
          <Box
            sx={{
              display: "flex",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                flex: 1,
                padding: "8px",
                borderBottom: "2px solid #2196f3",
                backgroundColor: "#f8fbff",
                boxShadow: "-2px 4px 4px 0px #00000040",
                border: "1px solid #a5dcf3",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <img src={busLocation} alt="" width="16" height="16" />
                  <Box
                    sx={{
                      borderRadius: "8px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                      {nextStopData.sourceStop}
                    </Typography>
                    <Typography sx={{ fontSize: "8px" }}>
                      {startTime}
                    </Typography>
                  </Box>
                </Box>
                <EastOutlinedIcon sx={{ fontSize: "16px" }} />
                <Box display="flex" alignItems="center" gap={1}>
                  <img src={busFlag} alt="" width="16" height="16" />
                  <Box
                    sx={{
                      borderRadius: "8px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                      {nextStopData.destinationStop}
                    </Typography>
                    <Typography sx={{ fontSize: "8px" }}>{endTime}</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Next Stop Box */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                border: "3px solid white",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
                borderRadius: "8px",
                padding: "8px",
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <img src={Busstop} alt="" width="16" height="16" />
                <Typography sx={{ color: "#008C23", fontSize: "10px" }}>
                  Next Stop
                </Typography>
              </Box>
              <Typography
                sx={{ fontSize: "14px", fontWeight: "bold", color: "#111214" }}
              >
                {nextStopData.nextStopName}
              </Typography>
            </Box>
          </Box>

          {/* Stats Row - 3 columns */}
          <Box sx={{ display: "flex", gap: "8px" }}>
            <MobileStatCard>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={0.5}
                mb={1}
              >
                <img src={distnaceIcon} alt="" width="16" height="16" />
                <Typography
                  sx={{ color: "#20A8E0", fontSize: "12px", fontWeight: 500 }}
                >
                  Distance
                </Typography>
              </Box>
              <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
                {nextStopData.distance}
                <Typography component="span" sx={{ fontSize: "10px", ml: 0.5 }}>
                  km
                </Typography>
              </Typography>
            </MobileStatCard>

            <MobileStatCard
              sx={
                isOverSpeeding
                  ? {
                      backgroundColor: "#ffebee",
                      border: "2px solid #d32f2f",
                    }
                  : {}
              }
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={0.5}
                mb={0.5}
              >
                <img src={speedIcon} alt="" width="16" height="16" />
                <Typography
                  sx={{
                    color: isOverSpeeding ? "#d32f2f" : "#20A8E0",
                    fontSize: "12px",
                    fontWeight: isOverSpeeding ? 700 : 500,
                  }}
                >
                  Speed
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: isOverSpeeding ? "#d32f2f" : "inherit",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0.5,
                }}
              >
                {isOverSpeeding && (
                  <Box
                    sx={{
                      width: "16px",
                      height: "16px",
                      backgroundColor: "#FF0000",
                      borderRadius: "50%",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#FFFFFF",
                      fontSize: "10px",
                      fontWeight: 700,
                      lineHeight: 1,
                    }}
                  >
                    ⚠
                  </Box>
                )}
                {nextStopData.speed}
                <Typography component="span" sx={{ fontSize: "10px", ml: 0.5 }}>
                  km/h
                </Typography>
              </Typography>
              {speedLimit != null && (
                <Typography
                  sx={{
                    fontSize: "9px",
                    color: isOverSpeeding ? "#d32f2f" : "#757575",
                    fontWeight: isOverSpeeding ? 600 : 400,
                    mt: 0.5,
                    textAlign: "center",
                  }}
                >
                  Limit: {speedLimit} km/h
                </Typography>
              )}
            </MobileStatCard>
            <MobileStatCard>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={0.5}
                mb={1}
              >
                <img src={etaIcon} alt="" width="16" height="16" />
                <Typography
                  sx={{ color: "#20A8E0", fontSize: "12px", fontWeight: 500 }}
                >
                  ETA
                </Typography>
              </Box>
              <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
                {nextStopData.eta}
              </Typography>
            </MobileStatCard>
          </Box>

          {/* Vehicle Row - 2 columns */}
          <Box sx={{ display: "flex", gap: "8px" }}>
            <Box
              sx={{
                flex: 1,
                display: "flex",
                minHeight: "60px",
                alignItems: "flex-start",
                flexDirection: "column",
                gap: "8px",
                padding: "8px",
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                border: "1px solid #a5dcf3",
                boxShadow: "-2px 4px 4px 0px #00000040",
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <img src={behindBus} alt="" width="16" height="16" />
                <Typography
                  sx={{ fontSize: "12px", color: "#414958", fontWeight: 500 }}
                >
                  Behind
                </Typography>
              </Box>
              <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
                {nextStopData.behindVehicle}
              </Typography>
            </Box>

            <Box
              sx={{
                flex: 1,
                display: "flex",
                minHeight: "60px",
                alignItems: "flex-start",
                flexDirection: "column",
                gap: "8px",
                padding: "8px",
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                border: "1px solid #a5dcf3",
                boxShadow: "-2px 4px 4px 0px #00000040",
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <img src={busAhead} alt="" width="16" height="16" />
                <Typography
                  sx={{ fontSize: "12px", color: "#414958", fontWeight: 500 }}
                >
                  Ahead
                </Typography>
              </Box>
              <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
                {nextStopData.aheadVehicle}
              </Typography>
            </Box>
          </Box>
        </MobileRowContainer>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <SOSButton
            onClick={handleSOSClick}
            disabled={isSendingSOS}
            sx={{
              opacity: isSendingSOS ? 0.7 : 1,
              cursor: isSendingSOS ? "not-allowed" : "pointer",
            }}
          >
            <WarningIcon size={28} />
            {isSendingSOS ? "Sending..." : "SOS"}
          </SOSButton>
          <PoweredBy>
            <Typography component="span">Powered by</Typography>
            {/* <RouteyeLogo src={routeeyeIcon} alt="RouteEye" />
            <RouteEyeBadge>RouteEye</RouteEyeBadge> */}
            <img src={RouteEyeIcon} alt="RouteEye" width="120" />
          </PoweredBy>
        </Box>
      </RightPanel>
    </Container>
  );
};

export default DriverConsoleCont;

export const MAP_ROTATION_ANGLE = 0;
export const uberMapOptions = {
  mapTypeId: "roadmap",
  disableDefaultUI: true,
  zoomControl: true,
  rotateControl: false,
  tilt: 0,
  styles: [
    {
      elementType: "geometry",
      stylers: [{ color: "#f5f5f5" }],
    },
    {
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [{ color: "#f5f5f5" }],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#dadada" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#c9c9c9" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
  ],
};

export const POSITION_HISTORY_SIZE = 20;
export const MOVEMENT_THRESHOLD = 5; // meters
export const TERMINAL_THRESHOLD = 60; // meters
export const ROUTE_PROXIMITY_THRESHOLD = 100; // meters

export const CONSTANTS = {
  STOP_RADIUS: 50, // meters
  STOP_VISIT_TIME: 10, // seconds
  DEPARTURE_DISTANCE: 30, // meters
  LOOK_AHEAD_DISTANCE: 1000, // meters
  DATA_STALENESS_THRESHOLD: 30000, // ms
  EARTH_RADIUS: 6371e3,
  MAX_STOP_DISTANCE: 800, // meters
  MIN_STOP_DISTANCE: 100, // meters
  AVG_SPEED: 35, // km/h
  MIN_STOP_TIME: 10, // seconds
  MAX_STOP_TIME: 100, // seconds
  TRAFFIC_MULTIPLIER: 1.1,
};

export const colors = [
  "#20A8E0",
  "#8FBC8F",
  "#FFD700",
  "#6495ED",
  "#FF69B4",
  "#FFA07A",
  "#ADFF2F",
  "#FF4500",
  "#9370DB",
  "#FFFFFF",
];

export const MAP_ORIENTATION = {
  VERTICAL_ANGLE: 0,
  DEFAULT_ZOOM: 15,
  MIN_ZOOM: 13,
  MAX_ZOOM: 18,
  PADDING: 100,
};
